import { ResidentStateReportingScreen } from "app/screens/residents/show/ResidentStateReportingScreen";

export default function ResidentStateReportingPage() {
  return <ResidentStateReportingScreen />;
}
